import { render, staticRenderFns } from "./ClasificacionArtistasPorIncrementoPorcentualSeguidores.vue?vue&type=template&id=9c93d4e0&"
import script from "./ClasificacionArtistasPorIncrementoPorcentualSeguidores.vue?vue&type=script&lang=js&"
export * from "./ClasificacionArtistasPorIncrementoPorcentualSeguidores.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionArtistasPorIncrementoPorcentualSeguidores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports